import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-action-list-item.css';
import { classNames } from '../../utils/classnames/index.esm.js';
import { useEGDSContext } from '../../utils/context-provider/index.esm.js';
const getClassNameList = classNames.bind(styles);
// Defines the span that provides the aria description
const setAriaDescription = (desc, id) => desc ? jsx("span", {
  className: "is-visually-hidden",
  id: id,
  children: desc
}) : jsx(Fragment, {});
const EGDSActionListItemLink = props => {
  const {
    children,
    visuallyHideLinkText
  } = props;
  const {
    data: contextData
  } = useEGDSContext();
  const {
    contextAriaDesc
  } = contextData ?? {};
  const childrenArray = React.Children.toArray(children);
  const firstChild = childrenArray[0];
  const randomId = Math.random().toString(36).substring(7);
  const uniqueSpanId = `selector-description-${randomId}`;
  if (!childrenArray || childrenArray.length !== 1) {
    console.warn(`UitkActionListItemLink uses the first child element. ${childrenArray.length} children found.`);
    return null;
  }
  const decoratedFirstChild = React.cloneElement(firstChild, {
    className: getClassNameList(firstChild.props.className, 'uitk-action-list-item-link', !visuallyHideLinkText && `uitk-action-list-item-link-has-visible-text`),
    'aria-describedby': contextAriaDesc ? uniqueSpanId : ''
  }, visuallyHideLinkText ? jsxs("span", {
    className: "is-visually-hidden",
    children: [setAriaDescription(contextAriaDesc, uniqueSpanId), firstChild.props.children]
  }) : jsxs(Fragment, {
    children: [setAriaDescription(contextAriaDesc, uniqueSpanId), firstChild.props.children]
  }));
  return decoratedFirstChild;
};
EGDSActionListItemLink.defaultProps = {
  visuallyHideLinkText: true
};
EGDSActionListItemLink.displayName = 'EGDSActionListItemLink';
export { EGDSActionListItemLink };